import React, {Component} from 'react';
import {DatePicker, Input, TimePicker} from "antd";
import Moment from 'moment';
import * as PropTypes from "prop-types";

class DateTimePicker extends Component {
  render() {
    let {
      className,
      style,
      format,
      defaultTime,
      value,
      ...rest
    } = this.props;

    return (<Input.Group compact>
      <DatePicker
        className={className}
        style={style}
        format={format || 'MM/DD/YYYY HH:mm:ss'}
        value={value}
        showTime={{
          minuteStep: 15,
          use12Hours: true,
          defaultValue: Moment(defaultTime || '14:00:00', 'HH:mm:ss'),
          format: 'h:mm A',
        }}
        placeholder={'Type or select a date'}
        {...rest}
      />
    </Input.Group>);
  }
}

DateTimePicker.propTypes = {
  className: PropTypes.any,
  style: PropTypes.any,
  timePickerClassName: PropTypes.any,
  timePickerStyle: PropTypes.any,
  format: PropTypes.any,
  timeFormat: PropTypes.any,
  props: PropTypes.any,
  timeProps: PropTypes.any,
  value: PropTypes.any
}

export default DateTimePicker;


// WEBPACK FOOTER //
// ./src/components/Boilerplate/DateTimePicker.js